import { isArray, isObject } from 'lodash';

export default function($filter) {
  'ngInject';

  return (array = []) => {
    if (isArray(array)) {
      array = array.reduce((arr, item) => {
        if (isObject(item) && item.hours) arr.push(...item.hours);
        else arr.push(item);
        return arr;
      }, []);
    }

    const arrayTotal = array.reduce((total, item) => {
      if (isNaN(item.credits)) return total;
      total += item ? item.credits : 0;
      return total;
    }, 0);

    return $filter('number')(arrayTotal, 2);
  };
}



// WEBPACK FOOTER //
// ./src/app/filters/TotalHours.js